import { render, staticRenderFns } from "./DataTypeSwitch.vue?vue&type=template&id=39c00232"
import script from "./DataTypeSwitch.vue?vue&type=script&lang=ts"
export * from "./DataTypeSwitch.vue?vue&type=script&lang=ts"
import style0 from "./DataTypeSwitch.vue?vue&type=style&index=0&id=39c00232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports